// extracted by mini-css-extract-plugin
export var phone = "_28-0";
export var phoneDragging = "_28-1";